export default __webpack_public_path__ + "static/media/livingRoom2.4c780045.jpeg";